import { responseError } from '../../../core/Api/ResponseError';
import { BadRequestResponse } from '../../../server/response/BadRequestResponse';
import { NoContentResponse } from '../../../server/response/NoContentResponse';
import { NotFoundResponse } from '../../../server/response/NotFoundResponse';
import { UnprocessableContentResponse } from '../../../server/response/UnprocessableContentResponse';

export async function handleResponse<Data>(response: Response): Promise<Data> {
    if (response.status === NotFoundResponse.status) {
        throw NotFoundResponse.error(`404 Not Found from ${response.url}`);
    }

    if (response.status === BadRequestResponse.status) {
        throw BadRequestResponse.error(`400 Bad Request from ${response.url}`);
    }

    if (response.status === UnprocessableContentResponse.status) {
        throw UnprocessableContentResponse.error(`422 Unprocessable Content from ${response.url}`);
    }

    if (response.status < 200 || response.status >= 300) {
        throw await responseError(response);
    }

    if (response.status === NoContentResponse.status) {
        return undefined as Data;
    }

    return response.json() as Promise<Data>;
}

export function catchNotFoundResource(error: unknown) {
    if (error instanceof NotFoundResponse.Error) {
        return undefined;
    }
    throw error;
}
